module.exports = __webpack_public_path__ + "img/zircly-placeholder.2bdc58bf.svg";